import request from '@/utils/request'

/**
 * 获取分销佣金列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listAffiliateCommission(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/affiliateCommission.listAffiliateCommission',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}